import { NavLink } from "react-router-dom";
import './ListView.css';

const ListView = ({ products }) => {
  return (
    <div className="section">
      <div className="container grid">
        {products.map((curElem) => {
          const { id, name, image, onelinerdescription } = curElem;
          return (
            <div key={id} className="card grid grid-two-column">
              <figure>
                <img src={image} alt={name} />
              </figure>

              <div className="card-data">
                <h3>{name}</h3>
                <p>{onelinerdescription}...</p>

                <NavLink to={`/singleProduct/${id}`} className="btn-main">
                  <button type="button" className="btn-read">
                    Read More
                  </button>
                </NavLink>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ListView;
